import React from "react";
import {
  useGlobalPeriod,
  usePerformanceHook,
  useReportBespoke,
} from "@iliotech/data-wire";
import s from "./PerformanceVsBenchmarWidget.module.scss";
import cn from "classnames";
import { ReportWidgetProps } from "../../ReportWidgetProps";
import PortfolioBenchmarkingModal from "src/components/__pageComponents/PerformancePage/PortfolioBenchmarkingModal/PortfolioBenchmarkingModal";
import { BenchmarkPerformanceChart } from "src/components/__pageComponents/PerformancePage/BenchmarkPerformanceChart/BenchmarkPerformanceChart";
import ToggableBenchmarkItems from "src/components/ToggableBenchmarkItems/ToggableBenchmarkItems";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";

export const PerformanceVsBenchmarkWidget = observer(
  (props: ReportWidgetProps) => {
    const { portfolioId } = useParams();
    const { portfolioController, benchmarkController } = usePerformanceHook(
      portfolioId!,
      true,
      props.periodContext,
      props.structureContext
    );
    const { performanceLoading, pnlPerformance, performanceLineChartData } =
      portfolioController;
    const {
      updateBenchmarks,
      filteredDefaultBenchmarks,
      benchmarksLoading,
      selectedBenchmarks,
      onBenchmarkItemDelete,
      toggleBenchmarkLineVisibility,
      portfolioBenchmarks,
    } = benchmarkController;
    const performanceBenchmarkName = pnlPerformance?.benchmarkName;
    const { periodString } = props.periodContext;
    const benchmarkOrPerformanceLoading =
      performanceLoading || benchmarksLoading;
    const [benchmarkSelectionVisible, setBenchmarkSelectionVisible] =
      React.useState(false);
    const store = useReportBespoke();
    const { generating } = store;

    return (
      <div className={cn(s.container, generating && s.generating)}>
        <PortfolioBenchmarkingModal
          loading={benchmarkOrPerformanceLoading}
          visible={benchmarkSelectionVisible}
          performanceBenchmarkName={performanceBenchmarkName}
          handleClose={() => setBenchmarkSelectionVisible(false)}
          portfolioBenchmarks={(portfolioBenchmarks || [])
            .filter((item) => !item.disabled)
            .map((item) => item.value)}
          updateBenchmarks={updateBenchmarks}
          defaultBenchmarks={filteredDefaultBenchmarks ?? []}
        />
        <BenchmarkPerformanceChart
          height={props.height}
          width={props.width}
          generating={generating}
          performanceBenchmarkName={performanceBenchmarkName}
          periodString={periodString}
          loading={
            benchmarkOrPerformanceLoading || !performanceLineChartData.length
          }
          performanceLineChartData={performanceLineChartData}
        />
        <ToggableBenchmarkItems
          generating={generating}
          benchmarks={portfolioBenchmarks}
          activeBenchmarks={selectedBenchmarks}
          onPress={toggleBenchmarkLineVisibility}
          onDelete={onBenchmarkItemDelete}
          onPlusPress={() => setBenchmarkSelectionVisible(true)}
        />
      </div>
    );
  }
);
